import { jsx } from 'react/jsx-runtime';
import { ClientContext, useClientContext as useClientContext$1 } from '@lemonade-hq/cdk';
import { useMemo } from 'react';
import { Client } from '../helpers/client/client.esm.js';

var ClientProvider = function(param) {
    var children = param.children;
    var client = useMemo(function() {
        return {
            getAxiosInstance: Client.getAxiosInstance,
            request: Client.request,
            get: Client.get,
            head: Client.head,
            post: Client.post,
            put: Client.put,
            patch: Client.patch,
            del: Client.del
        };
    }, []);
    return /*#__PURE__*/ jsx(ClientContext.Provider, {
        value: client,
        children: children
    });
};
var useClientContext = useClientContext$1;

export { ClientProvider, useClientContext };
